import { render, staticRenderFns } from "./EventAddForm.vue?vue&type=template&id=0ae23443"
import script from "./EventAddForm.vue?vue&type=script&lang=js"
export * from "./EventAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports